// Plan prices for the Pricing page.
//
// Native (iOS/Android): every figure comes from the store, never from our constants. The
// user's storefront decides currency and amount, and a mismatch between screens is
// reviewable. Grocerly v1.3.3 was rejected by Google Play for a hardcoded "~$X/month · Save
// 25%" beside store prices in pesos, where the real saving was 15%
// (~/.claude/skills/app-store-playbook, "Paywall UX must-haves").
//
// Web: Stripe charges USD at fixed prices, so one constant is the source, and every derived
// figure (per-month, saving) is computed from it rather than written out separately.

// Must match the Stripe Prices behind STRIPE_PLUS_MONTHLY_PRICE_ID / STRIPE_PLUS_ANNUAL_PRICE_ID.
export const WEB_PLUS_PRICES = Object.freeze({ monthly: 12, annual: 119.99 });

// Floored so it is never overstated; null when it can't be computed honestly.
function savePercent(monthly, annual) {
  if (!(monthly > 0) || !(annual > 0)) return null;
  const pct = Math.floor((1 - annual / (monthly * 12)) * 100);
  return pct > 0 ? pct : null;
}

export function planPricesFromOffering(offering) {
  const packages = offering?.packages || [];
  const monthly = packages.find(p => p.packageType === 'MONTHLY');
  const annual = packages.find(p => p.packageType === 'ANNUAL');
  if (!monthly && !annual) return null;
  const sameCurrency = monthly?.currencyCode && monthly.currencyCode === annual?.currencyCode;
  return {
    monthly: monthly ? { priceString: monthly.priceString } : null,
    annual: annual ? { priceString: annual.priceString, perMonthString: annual.pricePerMonthString || null } : null,
    savePercent: sameCurrency ? savePercent(monthly.price, annual.price) : null,
    hasFreeTrial: packages.some(p => p.hasFreeTrial),
  };
}

function usd(amount) {
  return Number.isInteger(amount) ? `$${amount}` : `$${amount.toFixed(2)}`;
}

export function webPlanPrices() {
  const { monthly, annual } = WEB_PLUS_PRICES;
  return {
    monthly: { priceString: usd(monthly) },
    annual: { priceString: usd(annual), perMonthString: usd(Math.round((annual / 12) * 100) / 100) },
    savePercent: savePercent(monthly, annual),
  };
}
